import { Component, inject, OnDestroy, ViewContainerRef } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

import { CxSnackbarService } from '@bbraun/cortex/snackbar';
import { OAuthEvent, OAuthService } from 'angular-oauth2-oidc';
import { Subject, takeUntil } from 'rxjs';

import { authCodeFlowConfig } from './modules/auth/config/auth-code-flow.config';
import { SplashScreenModule } from './modules/shared/components/splash-screen/splash-screen.module';

@Component({
  imports: [RouterOutlet, SplashScreenModule],
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnDestroy {
  private readonly oauthService = inject(OAuthService);
  private readonly router = inject(Router);

  private readonly onDestroy$ = new Subject<void>();

  constructor() {
    const snackbarService = inject(CxSnackbarService);
    const viewContainerRef = inject(ViewContainerRef);

    snackbarService.setViewContainerRef(viewContainerRef);
    this.configure();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  private configure(): void {
    this.oauthService.configure(authCodeFlowConfig);

    this.oauthService.setupAutomaticSilentRefresh();
    this.oauthService.loadDiscoveryDocumentAndTryLogin().then(
      () => {
        this.router.initialNavigation();
        this.setupAutomaticLogoutInCaseOfTokenExpiry();
      }
    );
  }

  private setupAutomaticLogoutInCaseOfTokenExpiry(): void {
    if (!this.oauthService.events) {
      return;
    }

    this.oauthService.events
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((event: OAuthEvent) => {
        if (event.type === 'token_expires') {
          this.router.navigateByUrl('login');
        }
      });
  }
}
